export default __webpack_public_path__ + "static/media/core.38438f75.png";